<template>
    <div class="job">
        <campaign-image :campaign="campaign" />

        <job-status :campaign="campaign" :outstanding-jobs="outstandingJobs" />

        <job-objective :campaign="campaign" />

        <job-tracking :campaign="campaign" />

		<div class="box">
			<campaign-dates :campaign="campaign" :show-proposal-dates="false" />
		</div>

        <job-assets :campaign="campaign" />

        <div class="box" v-if="content_rights">
            <div class="campaign-form-title mb-5">
                Content Rights
            </div>
            <content-rights-preview :content-rights="content_rights"/>
            <el-checkbox :value="true" >
                I accept the terms of the foregoing proposal and agree to the
                <a href="https://www.grin.co/privacy-policy" target="_blank">Privacy Policy</a>
                and
                <a href="https://www.grin.co/terms-of-use-influencers" target="_blank">Terms</a>
            </el-checkbox>
        </div>

        <job-deliverables :campaign="campaign" :jobs="jobs" />

        <proposal-files class="mb-100" :proposal="proposal" v-if="campaign.dates.content.after && campaign.allow_upload" />
    </div>
</template>

<script>
    import _ from 'lodash';
    import CampaignCustomizeMixin from '../../../mixins/CampaignCustomizeMixin';
    import CampaignImage from '../campaign/CampaignImage.vue';
    import JobStatus from './partials/JobStatus.vue';
    import JobObjective from './partials/JobObjective.vue';
    import JobTracking from './partials/JobTracking.vue';
    import JobAssets from './partials/JobAssets.vue';
    import JobDeliverables from './partials/JobDeliverables.vue';
    import ProposalFiles from './ProposalFiles.vue';
    import CampaignDates from "../campaign/CampaignDates";
    import ContentRightsPreview from "../campaign/proposal/ContentRightsPreview";

    export default {
        /**
         * The component name
         *
         * @type {String}
         */
        name: 'Job',

        /**
         * The component mixins
         *
         * @type {Array}
         */
        mixins: [
            CampaignCustomizeMixin
        ],

        /**
         * The child components
         *
         * @type {Object}
         */
        components: {
            CampaignDates,
            CampaignImage,
            JobStatus,
            JobObjective,
            JobTracking,
            JobAssets,
            JobDeliverables,
            ProposalFiles,
            ContentRightsPreview,
        },

        /**
         * The computed properties
         *
         * @type {Object}
         */
        computed: {
            /**
             * The job
             *
             * @returns {object}
             */
            proposal() {
                return this.$root.getProposal(this.$route.params.proposal_id);
            },

            /**
             * The job campaign
             *
             * @returns {object}
             */
            campaign() {
                return this.$root.getCampaign(this.proposal.campaign_id);
            },

            content_rights(){
                return _.get(this.proposal, 'content_rights.content_rights');
            },

            /**
             * The job proposal
             *
             * @returns {object}
             */
            jobs() {
                return this.$root.getJobs(this.proposal.id);
            },

            /**
             * The jobs that have not been delivered
             */
            outstandingJobs() {
                return this.jobs.filter(job => !job.delivered_at);
            }
        },

        /**
         * When the component is created
         *
         * @type {function}
         */
        created() {
            if (!this.proposal) {
                this.$root.go('sponsorships');
            }
        }
    }
</script>

